import { makeStyles } from '@material-ui/core/styles';

const useBusStopListItemStyles = makeStyles((theme) => ({
    avatar: {
        color: '#FFFFF',
        backgroundColor: props => props.avatarBackgroundColor? props.avatarBackgroundColor : '#000000'
    }
}));

export default useBusStopListItemStyles;